<template lang="pug">
v-app
  v-app-bar.re-app-bar(app :height="$vuetify.breakpoint.mdAndUp ? 70 : 60")
    v-container.d-flex.align-center
      v-btn(:disabled="registerLoading" icon @click="$goBack()")
        v-icon mdi-arrow-left
      v-spacer
      template
        v-btn.mr-2.text-h5.white--text(v-if="halykPosAllowed" :disabled="registerLoading || requestSent" @click="showPinpad('HALYK_POS')" color="green" width="110") Halyk Pos
        v-btn.mr-2.text-h5.white--text(v-if="kaspiQRAllowed" :disabled="registerLoading || requestSent" @click="showPinpad('KASPI_QR')" color="red" width="110") Каспи QR

    v-progress-linear(:active="registerLoading" :indeterminate="registerLoading" fixed top color="secondary")

  re-receipt(:ticket="ticket" :cashRegister="cashRegister" :organization="organization" :ticketLocale="getLocale()" :preTicket="true" style="margin-bottom: 180px;" @editParentTicket="returnParentTicketDialog = true")

  div.fixed-bottom
    div
      v-btn.title.white--text.mb-4(:disabled="registerLoading" @click="showPinpad()" block large color="secondary")
        v-icon.mr-2(v-if="qrFlowActive") mdi-qrcode-scan
        | {{ mainButtonLabel }}
    div(style="text-align: center;")
      v-btn.subtitle-1.text-decoration-underline(:disabled="registerLoading || requestSent" @click="operationTypeDialog = true" text color="primary") {{ $t("другие_операции") }}

  v-bottom-sheet(v-model="operationTypeDialog")
    v-list(subheader)
      v-subheader {{ $t("тип_операции") }}
      v-list-item(v-for="(operationType, $index) in filteredOperationTypes" :key="operationType.title" @click="selectOperationType(operationType)")
        v-list-item-avatar
          v-avatar(size="32px" tile)
            v-icon {{ operationType.icon }}
        v-list-item-title {{ $index + 1 }}. {{ operationType.title }}
      v-list-item.mt-3(color="primary" @click="operationTypeDialog = false")
        v-list-item-avatar
          v-avatar(size="32px" tile)
            v-icon mdi-close
        v-list-item-title {{ $t("отмена") }}

  re-pinpad(v-model="cashRegisterPinpadDialog" :title="$t('фискализация_чека')" :subtitle="$t('введите_пин-код')" :text="$t('для_фискализации')" :loading="cashRegisterPinpadLoading" :errorText.sync="cashRegisterPinpadErrorMessage" @action="checkPin")

  v-dialog(v-model="m4bankErrorDialog" scrollable fullscreen persistent width="500")
    v-card
      v-container
        v-row.mt-10
          v-col(align="center")
            v-icon(size="180" color="error") mdi-alert-circle-outline

        v-row.mt-10
          v-col
            .title.text-center {{ m4bankErrorText }}

        v-row.mt-10
          v-col(align="center")
            v-btn(large color="error" width="250" @click="m4bankErrorDialog = false") {{ $t("закрыть") }}

  v-dialog(v-model="kaspiQRDialog" persistent max-width="400px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.pa-0.pt-3.pr-3
        v-toolbar(dense flat)
          v-spacer
          v-btn(icon @click="kaspiQRDialog = false")
            v-icon mdi-close

      v-container
        v-row
          v-col
            .re-number-font.text-h1.text-center {{ totalSum | numeral('0,0.[00]') }} ₸

        v-row.mt-4
          v-col
            v-row(justify="center")
              img.kaspi-qrcode-img(src="/static/icons/kaspi-qr-small.png" height="36" width="36")
              div.kaspi-corners
                div.kaspi-qrcode
                  qrcode(:value="kaspiQR" size="140" level="H" renderAs="svg")

        v-row.mt-6
          v-col(cols="10" offset="1")
            v-list(style="background-color: var(--v-reBackground-base) !important")
              v-list-item
                v-list-item-icon
                  img.ml-4.mr-2(src="/static/icons/kaspi-qr.png" height="30" width="30")
                v-list-item-content
                  v-list-item-title.font-weight-bold Каспи QR
                  v-list-item-title {{ $t("сканируйте_и_платите") }}

        v-row.my-10
          v-col(align="center")
            v-btn.text-h3(large color="secondary" max-width="300" @click="kaspiQRPaid()") {{ $t("фискализировать_чек") }}

  re-halyk-qr-payment(ref="halykQRPayment" v-model="halykQRPaymentDialog" :cashRegister="cashRegister" :organization="organization" :amount="totalSum" @paid="halykQRPaid")

  re-halyk-qr-refund(v-model="halykQRRefundDialog" :amount="totalSum" :bill-number="refundBillNumber" @refunded="halykQRRefunded" @edit-bill-number="refundBillNumberDialog = true")

  v-dialog(v-model="refundBillNumberDialog" max-width="400px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title
        span.headline.mt-4 {{ $t("номер_операции_halyk_qr") }}
      v-card-text.pb-0
        v-container.pt-0
          v-form(ref="refundBillNumberForm" @submit.prevent="saveRefundBillNumber()")
            v-alert.subtitle-2.mt-0(color="warning" text) {{ $t("номер_операции_указан_на_чеке_продажи") }}
            v-text-field(:label="$t('номер_операции')" v-model="refundBillNumber" type="tel" :rules="[rules.required, rules.numbersOnly]" autocomplete="off" validate-on-blur maxlength="20" clearable :autofocus="!$isCordova()")
      v-divider
      v-card-actions
        v-spacer
        v-btn(outlined @click="refundBillNumberDialog = false") {{ $t("отменить") }}
        v-btn(color="primary" @click="saveRefundBillNumber()") {{ $t("сохранить") }}

  v-dialog(v-model="returnParentTicketDialog" max-width="400px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title
        span.headline.mt-4 {{ $t("введите_данные_возвратного_чека") }}
      v-card-text.pb-0
        v-container.pt-0
          v-form(ref="returnParentTicketForm" @submit.prevent="saveReturnParentTicket()")
            v-alert.subtitle-2.mt-0( color="warning" text) {{ $t("для_оформления_возврата_укажите_данные_исходного_чека_на_основании_которого_производится_возврат") }}

            v-text-field(:label="$t('регистрационный_номер_кассы_рнм')" v-model="returnParentTicketRegistrationNumber" type="tel" :rules="[rules.required, rules.numbersOnly]" autocomplete="off" validate-on-blur maxlength="20" clearable)
            v-text-field(:label="$t('фискальный_признак_чека_фп')" v-model="returnParentTicketNumber" type="tel" :rules="[rules.required, rules.numbersOnly]" autocomplete="off" validate-on-blur maxlength="20" clearable)
            v-text-field(ref="dateTimeField" :label="$t('дата_и_время_продажи')" placeholder="ДД-ММ-ГГГГ ЧЧ:ММ:CC" v-model="returnParentTicketDateTime" :error-messages="returnParentTicketDateTimeErrorMessages" v-mask="dateTimeMask" :rules="[rules.length(19)]" validate-on-blur autocomplete="off" clearable @focus="returnParentTicketDateTimeErrorMessages = null" @click:clear="clearDateTime")
            re-numeric-input-field(:label="$t('сумма_чека')" v-model="returnParentTicketTotal" limit-decimal="2" :rules="[rules.numberRange(0.01, 1000000000, returnParentTicketTotal)]" suffix="₸" validate-on-blur autocomplete="off" clearable)
            v-checkbox(:label="$t('автономный_чек')" v-model="returnParentTicketOffline")

            v-btn.mt-4.mb-5.re-btn-wrap-text(outlined @click="scanQRReturnParentTicket()" v-if="$isCordova()")
              v-icon(left) mdi-qrcode-scan
              | {{ $t("сканировать_qr_код_возвратного_чека") }}

      v-divider
      v-card-actions
        v-spacer
        v-btn(outlined @click="returnParentTicketDialog = false") {{ $t("отменить") }}
        v-btn(color="primary" @click="saveReturnParentTicket()") {{ $t("сохранить") }}

</template>
<script>
import fdo from '@comrun/kfdo'
import { Decimal } from 'decimal.js'
import { mapState, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import qrcode from 'qrcode.vue'
import { getLocale } from '../../i18n/index'
import dictionaryMixin from '../../mixins/dictionaryMixin'
import billsAndCoinsMixin from '../../mixins/billsAndCoinsMixin'
import dateMixin from '../../mixins/dateMixin'
import qrPaymentMixin from '../../mixins/qrPaymentMixin'
import store from '../../store/index'
import Receipt from './parts/Receipt.vue'
import HalykQRPayment from './parts/HalykQRPayment.vue'
import HalykQRRefund from './parts/HalykQRRefund.vue'
import Pinpad from '../utils/PinpadDialog.vue'
import NumericInputField from '../utils/NumericInputField.vue'
import { dateTimeMask } from '../../utils/masks'

export default {
  components: {
    qrcode,
    're-receipt': Receipt,
    're-halyk-qr-payment': HalykQRPayment,
    're-halyk-qr-refund': HalykQRRefund,
    're-pinpad': Pinpad,
    're-numeric-input-field': NumericInputField,
  },

  mixins: [dictionaryMixin, billsAndCoinsMixin, dateMixin, qrPaymentMixin],

  data: () => ({
    uuidString: null,
    selectedOperationType: null,
    ticketRequest: null,
    ticketRequestUpdateKey: 0, // Триггер для обновления computed
    registerLoading: false,
    operationTypeDialog: false,
    taken: null,
    flow: null,

    cashRegisterPinpadDialog: false,
    cashRegisterPinpadLoading: false,
    cashRegisterPinpadErrorMessage: null,

    requestSent: false,

    m4bankType: null,
    m4bankAttributes: null,
    m4bankErrorDialog: false,
    m4bankErrorText: null,

    kaspiQRDialog: false,
    halykQRPaymentDialog: false,
    halykQRRefundDialog: false,
    refundBillNumber: null,
    refundBillNumberDialog: false,

    returnParentTicketDialog: false,
    returnParentTicketNumber: null,
    returnParentTicketRegistrationNumber: null,
    returnParentTicketDateTime: null,
    returnParentTicketDateTimeErrorMessages: null,
    returnParentTicketTotal: null,
    returnParentTicketOffline: false,

    dateTimeMask,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      organization: state => state.cashRegisters.cashRegister.organization,
      preferences: state => state.cashRegisters.cashRegister.cashRegister.data.preferences,
      configuration: state => state.cashRegisters.cashRegister.cashRegister.data.configuration,
      cashRegisterPinChecked: state => state.cashRegisters.cashRegisterPinChecked,
      hasNFC: state => state.m4bank.hasNFC,
      hasAndroid8AndAbove: state => state.m4bank.hasAndroid8AndAbove,
      printerSettings: state => state.printer.settings,
    }),

    filteredOperationTypes() {
      return this.operationTypes.filter((operationType) => (this.preferences.buyMode ? true : (!(operationType.value === 'OPERATION_BUY' || operationType.value === 'OPERATION_BUY_RETURN'))))
    },

    ticket() {
      // Добавляем зависимость от ticketRequestUpdateKey для отслеживания изменений
      this.ticketRequestUpdateKey // eslint-disable-line no-unused-expressions
      return {
        data: {
          ticket: this.ticketRequest.toJSON(),
        },
      }
    },

    totalSum() {
      return this.getNumberFromBillsAndCoins(this.$store.state.cashRegisters.ticketRequest.amounts.total)
    },

    halykPosAllowed() {
      return this.selectedOperationType === 'OPERATION_SELL' && this.configuration.halyk && this.configuration.halyk.halykPosConnected
    },

    kaspiQRAllowed() {
      return this.selectedOperationType === 'OPERATION_SELL' && this.configuration.kaspiQR && this.configuration.kaspiQR.connected
    },

    halykQRAllowed() {
      return this.selectedOperationType === 'OPERATION_SELL' && this.halykQRConnected
    },

    halykQRRefundAllowed() {
      return this.selectedOperationType === 'OPERATION_SELL_RETURN' && this.halykQRConnected
    },

    // Продажа или возврат идут через Единый QR - на кнопке значок QR
    qrFlowActive() {
      this.ticketRequestUpdateKey // eslint-disable-line no-unused-expressions
      return (this.halykQRAllowed || this.halykQRRefundAllowed) && this.hasQrPaymentMarker(this.ticketRequest)
    },

    // Продажа через Единый QR: кнопка принимает оплату по QR, а не просто фискализирует
    qrSaleFlowActive() {
      this.ticketRequestUpdateKey // eslint-disable-line no-unused-expressions
      return this.halykQRAllowed && this.hasQrPaymentMarker(this.ticketRequest)
    },

    mainButtonLabel() {
      this.ticketRequestUpdateKey // eslint-disable-line no-unused-expressions
      if (!this.selectedOperationType) {
        return '-----------------'
      }
      const sum = `${this.$options.filters.numeral(this.totalSum, '0,0.[00]')} ₸`
      return this.qrSaleFlowActive ? `${this.$t('принять_оплату')} ${sum}` : `${this.$t(`operationType.${this.selectedOperationType}`)} ${sum}`
    },

    kaspiQR() {
      return this.configuration?.kaspiQR?.qr
    },
  },

  created() {
    this.uuidString = uuidv4()
    const storedTicketRequest = this.$store.state.cashRegisters.ticketRequest
    this.updateTicketRequest(storedTicketRequest)

    // Backup taken
    this.taken = storedTicketRequest.amounts.taken

    this.returnParentTicketRegistrationNumber = this.cashRegister.registrationNumber
    this.returnParentTicketTotal = this.getNumberFromBillsAndCoins(storedTicketRequest.amounts.total)

    // Повторный заход на /draft (например, назад с Z-отчёта после «требуется закрыть смену»):
    // восстанавливаем выбор пользователя из draftOperationType - служебного поля на
    // store-объекте (proto .toJSON() его не сериализует, живёт ровно столько, сколько драфт).
    // «Внесение/Изъятие» пересобираем так же, как selectOperationType
    const savedSelection = storedTicketRequest.draftOperationType
    if (savedSelection === 'MONEY_PLACEMENT_DEPOSIT' || savedSelection === 'MONEY_PLACEMENT_WITHDRAWAL') {
      const moneyPlacemenTicketRequest = new fdo.kkm.proto.MoneyPlacementRequest()
      moneyPlacemenTicketRequest.operation = fdo.kkm.proto.MoneyPlacementEnum[savedSelection]
      moneyPlacemenTicketRequest.sum = this.getBillsAndCoinsMoney(this.totalSum)
      this.selectedOperationType = savedSelection
      this.updateTicketRequest(moneyPlacemenTicketRequest)
      return
    }
    if (['OPERATION_SELL', 'OPERATION_SELL_RETURN', 'OPERATION_BUY', 'OPERATION_BUY_RETURN'].includes(savedSelection)) {
      this.selectedOperationType = savedSelection
      return
    }

    // Драфт без сохранённого выбора (первый заход с калькулятора/инвентаря): по enum.
    // OPERATION_BUY = 0 совпадает с protobuf-default «не задано» - его не восстанавливаем
    const operationName = fdo.kkm.proto.OperationTypeEnum[storedTicketRequest.operation]
    this.selectedOperationType = ['OPERATION_SELL', 'OPERATION_SELL_RETURN', 'OPERATION_BUY_RETURN'].includes(operationName) ? operationName : null
  },

  beforeRouteEnter(to, from, next) {
    if (store.state.cashRegisters.ticketRequest) {
      next()
    } else {
      next('/kkm')
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'TicketPrint' && this.registerLoading) {
      this.showSnackbar({ message: this.$t('пожалуйста_дождитесь_окончания_процесса') })
      next(false)
      return
    }

    // «Назад» во время оплаты Единым QR: не уходим, диалог сам решает
    // по своему состоянию (алерт отмены / закрыться / игнор)
    if (this.halykQRPaymentDialog) {
      if (this.$refs.halykQRPayment) {
        this.$refs.halykQRPayment.onBackPressed()
      }
      next(false)
      return
    }

    // Возврат отменять нечем (reject для возвратного QR нет) - просто не даём уйти
    if (this.halykQRRefundDialog) {
      this.showSnackbar({ message: this.$t('пожалуйста_дождитесь_окончания_процесса') })
      next(false)
      return
    }

    next()
  },

  mounted() {
    window.addEventListener('keydown', this.keyListener, false)
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.keyListener, false)
  },

  methods: {
    ...mapActions({
      registerTicket: 'cashRegisters/registerTicket',
      registerCash: 'cashRegisters/registerCash',
      setTicketRequest: 'cashRegisters/setTicketRequest',
      setTicket: 'cashRegisters/setTicket',
      setTicketBulkAttributes: 'cashRegisters/setTicketBulkAttributes',
      checkPassword: 'cashRegisters/checkPassword',
      setCashRegisterPinChecked: 'cashRegisters/setCashRegisterPinChecked',
      m4bankRequestOperation: 'm4bank/requestOperation',
      showSnackbar: 'tools/showSnackbar',
      showConfirm: 'confirm/showConfirm',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    // Костыли из-за нового протокола ОФД 2.0.3 с parentTicket для возвратных чеков
    // Раньше тело чека не менялось на этапе draft, теперь меняется
    // Метод для обновления ticketRequest с триггером реактивности
    updateTicketRequest(value) {
      this.ticketRequest = value
      this.ticketRequestUpdateKey += 1
    },

    // Метод для обновления свойств ticketRequest
    triggerTicketUpdate() {
      this.ticketRequestUpdateKey += 1
    },

    getLocale() {
      return getLocale()
    },

    keyListener(event) {
      if (!this.cashRegisterPinpadDialog && !this.registerLoading && !this.returnParentTicketDialog && !this.refundBillNumberDialog) {
        const reg = new RegExp('^[1-7]$')
        if (event.key === 'Backspace') {
          this.$router.push('/details')
        } else if (event.key === ' ') {
          this.operationTypeDialog = true
        } else if (event.key === 'Escape') {
          this.operationTypeDialog = false
        } else if (reg.test(event.key)) {
          const operationType = this.filteredOperationTypes[event.key - 1]
          if (operationType && !this.requestSent) {
            this.selectOperationType(operationType)
          }
        } else if (event.key === 'Enter') {
          this.showPinpad()
        }
      }
    },

    processItemsForAnalytics(result) {
      if (result.data?.data?.ticket?.operation === 'OPERATION_SELL') {
        result.data?.data?.ticket?.items.forEach((item) => {
          if (item.commodity) {
            this.analyticsLogEvent({
              eventName: 're_ticket_registered_commodity_name',
              eventProperties: {
                type:
              item.commodity.name === this.preferences.defaultItemName ? 'default' : 'unique',
              },
            })
          }
        })
      result.data?.data?.ticket?.payments.forEach((item) => {
        this.analyticsLogEvent({
          eventName: 're_ticket_registered_payment_type',
          eventProperties: { type: item.type },
        })
      })
      }
    },

    selectOperationType(operationType) {
      this.updateTicketRequest(this.$store.state.cashRegisters.ticketRequest)

      const hasChange = this.ticketRequest.amounts && this.ticketRequest.amounts.change && this.getNumberFromBillsAndCoins(this.ticketRequest.amounts.change) > 0
      let hasItemDiscount = false
      let hasItemMarkup = false
      if (this.ticketRequest.items) {
        this.ticketRequest.items.forEach(item => {
          if (item.type === fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_COMMODITY) {
            hasItemDiscount = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT') !== undefined
            hasItemMarkup = item.commodity.auxiliary.find((aux) => aux.key === 'MARKUP') !== undefined
          }
        })
      }

      if (hasChange && (operationType.value === 'OPERATION_SELL_RETURN' || operationType.value === 'OPERATION_BUY')) {
        this.selectedOperationType = null
        this.showSnackbar({ message: this.$t('сдача_не_допустима_в_операции', { operation: operationType.title }) })
        this.operationTypeDialog = false
        return
      }

      if (['MONEY_PLACEMENT_DEPOSIT', 'MONEY_PLACEMENT_WITHDRAWAL'].indexOf(operationType.value) >= 0 && (hasChange || hasItemDiscount || hasItemMarkup)) {
        this.selectedOperationType = null
        this.showSnackbar({ message: this.$t('скидка_наценка_и_сдача_не_допустимы_в_операции', { operation: operationType.title }) })
        this.operationTypeDialog = false
        return
      }

      if (operationType.value !== 'OPERATION_SELL_RETURN' && operationType.value !== 'OPERATION_BUY_RETURN') {
        this.clearReturnParentTicket()
      }

      if (['OPERATION_SELL', 'OPERATION_SELL_RETURN', 'OPERATION_BUY', 'OPERATION_BUY_RETURN'].indexOf(operationType.value) >= 0) {
        this.ticketRequest.operation = fdo.kkm.proto.OperationTypeEnum[operationType.value]
        this.ticketRequest.draftOperationType = operationType.value // переживает уход со страницы (см. created)
        this.selectedOperationType = operationType.value
        this.operationTypeDialog = false

        // Exception for OPERATION_SELL_RETURN
        if (operationType.value === 'OPERATION_SELL_RETURN' || operationType.value === 'OPERATION_BUY') {
          this.ticketRequest.amounts.taken = this.getBillsAndCoinsMoney(0)
        } else {
          // Restoring from backup
          this.ticketRequest.amounts.taken = this.taken
        }
        this.triggerTicketUpdate()
      } else if (['MONEY_PLACEMENT_DEPOSIT', 'MONEY_PLACEMENT_WITHDRAWAL'].indexOf(operationType.value) >= 0) {
        // this.ticketRequest сейчас - store-объект TicketRequest (перечитан выше);
        // выбор пишем на него ДО подмены на локальный MoneyPlacementRequest
        this.ticketRequest.draftOperationType = operationType.value
        const moneyPlacemenTicketRequest = new fdo.kkm.proto.MoneyPlacementRequest()
        moneyPlacemenTicketRequest.operation = fdo.kkm.proto.MoneyPlacementEnum[operationType.value]
        moneyPlacemenTicketRequest.sum = this.getBillsAndCoinsMoney(this.totalSum)
        this.selectedOperationType = operationType.value
        this.updateTicketRequest(moneyPlacemenTicketRequest)
        this.operationTypeDialog = false
      }
    },

    clearDateTime() {
      this.returnParentTicketDateTime = null
      this.$nextTick(() => {
        if (this.$refs.dateTimeField && this.$refs.dateTimeField.$refs.input) {
          this.$refs.dateTimeField.$refs.input.value = ''
        }
      })
    },

    saveReturnParentTicket() {
      if (this.$refs.returnParentTicketForm.validate()) {
        if (!this.$moment(this.returnParentTicketDateTime, 'DD-MM-YYYY HH:mm:ss').isValid()) {
          this.returnParentTicketDateTimeErrorMessages = this.$t('некорректная_дата')
          return
        }
        this.returnParentTicketDateTimeErrorMessages = null

        const parentTicket = new fdo.kkm.proto.TicketRequest.ParentTicket({
          parentTicketNumber: this.returnParentTicketNumber,
          kgdKkmId: this.returnParentTicketRegistrationNumber,
          parentTicketDataTime: this.toProtoDateTime(this.$moment(this.returnParentTicketDateTime, 'DD-MM-YYYY HH:mm:ss')),
          parentTicketTotal: this.getBillsAndCoinsMoney(this.returnParentTicketTotal),
          parentTicketIsOffline: this.returnParentTicketOffline,
        })
        this.ticketRequest.parentTicket = parentTicket
        this.triggerTicketUpdate()

        this.returnParentTicketDialog = false

        // Возврат Halyk QR: сразу спрашиваем номер операции исходного платежа
        if (this.halykQRRefundAllowed && this.hasQrPaymentMarker(this.ticketRequest) && !this.refundBillNumber) {
          this.refundBillNumberDialog = true
        }
      }
    },

    saveRefundBillNumber() {
      if (this.$refs.refundBillNumberForm.validate()) {
        this.refundBillNumberDialog = false
        // Продолжаем флоу без повторного нажатия кнопки «Возврат»
        this.showPinpad('HALYK_QR_REFUND')
      }
    },

    clearReturnParentTicket() {
      // Очищаем возвратный чек
      this.ticketRequest.parentTicket = null

      // Очищаем данные возвратного чека
      this.returnParentTicketNumber = null
      this.clearDateTime()
      this.returnParentTicketTotal = null
      this.returnParentTicketOffline = false
      this.refundBillNumber = null

      this.triggerTicketUpdate()
    },

    scanQRReturnParentTicket() {
      const aspectRatio = parseInt(localStorage.getItem('rekassa.kz-ui-camera-aspectRatio') || 1, 10)
      window.cordova.plugins.rekassaBarcode.scan((qr) => {
        try {
          // Используем URL API для корректного парсинга полного URL
          const url = new URL(qr)
          const params = url.searchParams

          this.returnParentTicketNumber = params.get('i')
          this.returnParentTicketRegistrationNumber = params.get('f')
          this.returnParentTicketDateTime = this.$moment(params.get('t'), 'YYYYMMDDTHHmmss').format('DD-MM-YYYY HH:mm:ss').toString()
          this.returnParentTicketTotal = params.get('s')

          // Обновляем значение input поля напрямую для корректной работы с v-mask
          if (this.$refs.dateTimeField && this.$refs.dateTimeField.$refs.input) {
            this.$refs.dateTimeField.$refs.input.value = this.returnParentTicketDateTime
          }

          this.$nextTick(() => {
            this.saveReturnParentTicket()
          })
        } catch (error) {
          console.log(error)
        }

        this.analyticsLogEvent({ eventName: 're_return_parent_ticket_scanned' })
      },
      () => {}, { aspectRatio })
    },

    // Start
    showPinpad(type) {
      let flow = type || 'DEFAULT'

      // Выбран тип оплаты «QR» (метка в extensionOptions.auxiliary) -
      // кнопка «Продажа»/«Возврат» сразу запускает флоу Halyk QR
      if (flow === 'DEFAULT' && this.halykQRAllowed && this.hasQrPaymentMarker(this.ticketRequest)) {
        flow = 'HALYK_QR'
      }
      if (flow === 'DEFAULT' && this.halykQRRefundAllowed && this.hasQrPaymentMarker(this.ticketRequest)) {
        flow = 'HALYK_QR_REFUND'
      }

      this.flow = flow

      // Check if operation type selected
      if (this.selectedOperationType === null) {
        this.showSnackbar({ message: this.$t('выберите_тип_операции') })
        return
      }

      // Check if shift expired
      if (this.checkIfShiftExpired()) return

      // Check Halyk POS requirements
      if (this.flow === 'HALYK_POS') {
        if (!this.hasAndroid8AndAbove || !this.hasNFC) {
          this.showSnackbar({ message: this.$t('для_того_чтобы_начать_принимать_бесконтактные_платежи_требуется_dotdotdot') })
          return
        }

        const cardPayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_CARD)
        if (cardPayment === undefined) {
          this.showSnackbar({ message: this.$t('нет_суммы_для_оплаты_картой') })
          return
        }

        this.m4bankType = 'HALYK_POS'
        this.m4bankAttributes = null
      }

      // Check Kaspi QR requirements
      if (this.flow === 'KASPI_QR') {
        const cardPayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_MOBILE)
        if (cardPayment === undefined) {
          this.showSnackbar({ message: this.$t('нет_суммы_для_оплаты_qr') })
          return
        }

        if (this.ticketRequest.payments.length > 1) {
          this.showSnackbar({ message: this.$t('смешанная_оплата_не_поддерживается_в_kaspi_qr') })
          return
        }

        this.m4bankType = 'KASPI_QR'
        this.m4bankAttributes = null
      }

      // Check Halyk QR requirements
      if (this.flow === 'HALYK_QR') {
        const mobilePayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_MOBILE)
        if (mobilePayment === undefined) {
          this.showSnackbar({ message: this.$t('нет_суммы_для_оплаты_qr') })
          return
        }

        if (this.ticketRequest.payments.length > 1) {
          this.showSnackbar({ message: this.$t('смешанная_оплата_не_поддерживается_в_halyk_qr') })
          return
        }

        this.m4bankType = 'HALYK_QR'
        this.m4bankAttributes = null
      }

      // Check Halyk QR refund requirements
      if (this.flow === 'HALYK_QR_REFUND') {
        const mobilePayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_MOBILE)
        if (mobilePayment === undefined) {
          this.showSnackbar({ message: this.$t('нет_суммы_для_оплаты_qr') })
          return
        }

        if (this.ticketRequest.payments.length > 1) {
          this.showSnackbar({ message: this.$t('смешанная_оплата_не_поддерживается_в_halyk_qr') })
          return
        }

        this.m4bankType = 'HALYK_QR'
        this.m4bankAttributes = null
      }

      // Проверка на заполнение данных возвратного чека
      if (this.selectedOperationType === 'OPERATION_SELL_RETURN' || this.selectedOperationType === 'OPERATION_BUY_RETURN') {
        if (!this.returnParentTicketNumber || !this.returnParentTicketRegistrationNumber || !this.returnParentTicketDateTime || !this.returnParentTicketTotal) {
          this.returnParentTicketDialog = true
          return
        }
      }

      // Для возврата Halyk QR нужен номер операции исходного платежа
      if (this.flow === 'HALYK_QR_REFUND' && !this.refundBillNumber) {
        this.refundBillNumberDialog = true
        return
      }

      // If cashRegister is in TRIAL mode or pin checked then continue
      if (this.cashRegister.status === 'TRIAL' || this.cashRegisterPinChecked) {
        this.doAfterPinChecked()
      } else {
        this.cashRegisterPinpadDialog = true
      }
    },

    checkPin(pincode) {
      this.cashRegisterPinpadLoading = true
      const form = new FormData()
      form.append('password', pincode)
      this.checkPassword({
        cashRegister: this.cashRegister,
        data: form,
      }).then((result) => {
        if (result.data.result) {
          this.cashRegisterPinpadDialog = false
          this.setCashRegisterPinChecked(true)
          this.doAfterPinChecked()
        } else {
          this.cashRegisterPinpadErrorMessage = this.$t('введен_неверный_пин-код')
        }
        this.cashRegisterPinpadLoading = false
      }).catch(() => {
        this.cashRegisterPinpadLoading = false
      })
    },

    doAfterPinChecked() {
      switch (this.flow) {
        case 'HALYK_POS':
          this.m4bankOperation(this.m4bankType)
          break
        case 'KASPI_QR':
          this.kaspiQRDialog = true
          break
        case 'HALYK_QR':
          this.halykQRPaymentDialog = true
          break
        case 'HALYK_QR_REFUND':
          this.halykQRRefundDialog = true
          break
        default:
          this.register()
          break
      }
    },

    // Register ticket
    register() {
      let total = 0

      if (this.selectedOperationType.includes('OPERATION')) {
        total = this.getNumberFromBillsAndCoins(this.ticketRequest.amounts.total)
      } else if (this.selectedOperationType.includes('MONEY')) {
        total = this.getNumberFromBillsAndCoins(this.ticketRequest.sum)
      }

      if (new Decimal(total).greaterThan(this.preferences.operationTotalLimit)) {
        this.showSnackbar({ message: this.$t('превышена_максимальная_сумма_чека_вы_можете_изменить_ее_в_меню_интерфейс', { maxSum: this.$options.filters.numeral(this.preferences.operationTotalLimit, '0,0') }), url: 'https://link.rekassa.kz/max-sum' })
        return
      }

      this.registerLoading = true
      this.requestSent = true

      // Register ticket
      if (this.selectedOperationType.includes('OPERATION')) {
        this.registerTicket({
          cashRegister: this.cashRegister,
          ticket: this.getTicketRequestJSON(this.ticketRequest),
          uuid: this.uuidString,
        }).then(async (result) => {
          if (this.cashRegister.status === 'REGISTERED') {
            this.analyticsLogEvent({
              eventName: 're_ticket_registered',
              eventProperties: {
                type: localStorage.getItem('rekassa.kz-ticket-prepared-from') || 'CALCULATOR',
              },
            })
            this.processItemsForAnalytics(result)
          }

          let ticket = result.data

          // Set M4bank attributes
          if (this.m4bankType) {
            const resultWithAttr = await this.setM4bankAttributes(result)
            ticket = resultWithAttr?.data || ticket

            this.analyticsLogEvent({
              eventName: 're_ticket_registered_payment_provider',
              eventProperties: { provider: this.m4bankType },
            })
          }

          this.setTicketRequest(null)
          this.setTicket(ticket)
          if (!this.$isCordova()) {
            this.showSnackbar({ message: this.$t('чек_№_успешно_фискализирован', { number: ticket.shiftDocumentNumber }), timeout: 1500 })
          }
          this.$router.push(`/print/${this.cashRegister.id}/${ticket.id}${this.printerSettings.autoPrint ? '?autoprint=true' : ''}`)
          this.registerLoading = false
          this.checkIfOffline(ticket)
        }).catch((error) => {
          this.processError(error)
          this.registerLoading = false
        })
      }

      // Register cash
      if (this.selectedOperationType.includes('MONEY')) {
        this.registerCash({
          cashRegister: this.cashRegister,
          cash: this.getMoneyPlacementRequestJSON(this.ticketRequest),
          uuid: this.uuidString,
        }).then((result) => {
          this.setTicketRequest(null)
          this.setTicket(result.data)
          if (!this.$isCordova()) {
            this.showSnackbar({ message: this.$t('чек_№_успешно_фискализирован', { number: result.data.shiftDocumentNumber }), timeout: 1500 })
          }
          this.$router.push(`/print/${this.cashRegister.id}/${result.data.id}}`)
          this.registerLoading = false
          this.checkIfOffline(result.data)
        }).catch((error) => {
          this.processError(error)
          this.registerLoading = false
        })
      }
    },

    setM4bankAttributes(result) {
      return new Promise((resolve) => {
        this.setTicketBulkAttributes({
          cashRegister: this.cashRegister,
          ticket: result.data,
          cfg: {
            params: {
              paymentType: this.m4bankType,
              m4bankMerchantName: this.m4bankAttributes?.merchantName,
              m4bankDateTime: this.m4bankAttributes?.dateTime,
              m4bankOperationDay: this.m4bankAttributes?.operationDay,
              m4bankTransactionNumber: this.m4bankAttributes?.transactionNumber,
              m4bankTerminalId: this.m4bankAttributes?.terminalId,
              m4bankMaskedPan: this.m4bankAttributes?.maskedPan,
              m4bankAuthorizationCode: this.m4bankAttributes?.authorizationCode,
              m4bankRRN: this.m4bankAttributes?.rrn,
            },
          },
        }).then((resultWithAttr) => {
          resolve(resultWithAttr)
        }).catch((error) => {
          this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
          resolve(null)
        })
      })
    },

    checkIfOffline(ticket) {
      if (this.cashRegister.fdoMode === 'ONLINE' && ticket.offline) {
        this.showSnackbar({ message: this.$t('внимание_касса_перешла_в_автономный_режим') })
      }
    },

    checkIfShiftExpired() {
      if (this.cashRegister.shiftExpired) {
        this.showConfirm({
          title: this.$t('требуется_закрыть_смену'),
          resolveText: this.$t('закрыть_смену'),
          rejectText: this.$t('отменить'),
        }).then(() => {
          this.$router.push(`/shifts/${this.cashRegister.id}/${this.cashRegister.shiftNumber}/zxreport`)
        }).catch(() => {})
        return true
      }
      return false
    },

    getTicketRequestJSON(ticketRequest) {
      // Generating Discount, Markup items
      if (ticketRequest.items) {
        const discountMarkupItems = []
        ticketRequest.items.forEach(item => {
          if (item.type === fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_COMMODITY) {
            // Item commodity tax
            const tax = item.commodity.taxes && item.commodity.taxes[0]

            // Item discount
            const discount = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT')
            if (discount) {
              const discountType = discount.value.includes('%') ? 'PERCENTAGE' : 'VALUE'
              const discountPercentage = discount.value.replace('%', '')
              const discountValue = discountType === 'PERCENTAGE' ? new Decimal(discountPercentage).times(this.getNumberFromBillsAndCoins(item.commodity.sum)).dividedBy(100).toNumber()
                .toFixed(2) : discount.value
              const discountItem = new fdo.kkm.proto.TicketRequest.Item({
                type: fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_DISCOUNT,
                discount: new fdo.kkm.proto.TicketRequest.Modifier({
                  sum: this.getBillsAndCoinsMoney(discountValue),
                  name: item.commodity.name,
                }),
              })

              const discountMarkupTax = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT_MARKUP_TAX')
              if (tax && discountMarkupTax) {
                discountItem.taxes = [
                  new fdo.kkm.proto.TicketRequest.Tax({
                    taxType: 100,
                    taxationType: tax.taxation_type,
                    percent: tax.percent,
                    sum: this.getBillsAndCoinsMoney(new Decimal(discountMarkupTax.value).abs()),
                    isInTotalSum: true,
                  }),
                ]
              }

              discountMarkupItems.push(discountItem)
            }

            // Item markup
            const markup = item.commodity.auxiliary.find((aux) => aux.key === 'MARKUP')
            if (markup) {
              const markupType = markup.value.includes('%') ? 'PERCENTAGE' : 'VALUE'
              const markupPercentage = markup.value.replace('%', '')
              const markupValue = markupType === 'PERCENTAGE' ? new Decimal(markupPercentage).times(this.getNumberFromBillsAndCoins(item.commodity.sum)).dividedBy(100).toNumber()
                .toFixed(2) : markup.value
              const markupItem = new fdo.kkm.proto.TicketRequest.Item({
                type: fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_MARKUP,
                markup: new fdo.kkm.proto.TicketRequest.Modifier({
                  sum: this.getBillsAndCoinsMoney(markupValue),
                  name: item.commodity.name,
                }),
              })

              const discountMarkupTax = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT_MARKUP_TAX')
              if (tax && discountMarkupTax) {
                markupItem.taxes = [
                  new fdo.kkm.proto.TicketRequest.Tax({
                    taxType: 100,
                    taxationType: tax.taxation_type,
                    percent: tax.percent,
                    sum: this.getBillsAndCoinsMoney(new Decimal(discountMarkupTax.value).abs()),
                    isInTotalSum: true,
                  }),
                ]
              }

              discountMarkupItems.push(markupItem)
            }
          }
        })
        ticketRequest.items = ticketRequest.items.concat(discountMarkupItems)
      }

      ticketRequest.dateTime = this.toProtoDateTime(new Date())

      // Operator
      ticketRequest.operator = new fdo.kkm.proto.Operator({ code: this.user.id, name: this.user.name })

      return ticketRequest.toJSON()
    },

    getMoneyPlacementRequestJSON(moneyPlacementRequest) {
      moneyPlacementRequest.datetime = this.toProtoDateTime(new Date())

      return moneyPlacementRequest.toJSON()
    },

    processError(error) {
      if (error && error.response && error.response.data && error.response.data.code === 'CASH_REGISTER_SHIFT_PERIOD_EXPIRED') {
        this.showConfirm({
          title: this.$t('требуется_закрыть_смену'),
          text: error.response.data.meta && error.response.data.meta.ALLOWED_SHIFT_MINUTES ? this.$t('прошло_больше_часов_с_начала_открытия_смены_dotdotdot', { hours: error.response.data.meta.ALLOWED_SHIFT_MINUTES / 60 }) : null,
          resolveText: this.$t('закрыть_смену'),
          rejectText: this.$t('отменить'),
        }).then(() => {
          this.$router.push(`/shifts/${this.cashRegister.id}/${this.cashRegister.shiftNumber}/zxreport`)
        }).catch(() => {})
      }
    },

    // HALYK POS
    m4bankOperation(type) {
      this.registerLoading = true
      this.m4bankRequestOperation({
        cashRegisterId: this.cashRegister.id,
        ticket: this.getTicketRequestJSON(this.ticketRequest),
        bankType: type,
      }).then((paymentResult) => {
        if (paymentResult && paymentResult.result && paymentResult.result.code === 0 && paymentResult.transaction) {
          this.m4bankType = type
          this.m4bankAttributes = paymentResult.transaction
          this.register()
        } else {
          this.m4bankErrorText = `${this.$t('ошибка_оплаты')}: ${paymentResult.result.errorData.description}`
          this.registerLoading = false
          this.m4bankErrorDialog = true
        }
      }).catch((error) => {
        this.m4bankErrorText = `${this.$t('ошибка_оплаты')}: ${error}`
        this.registerLoading = false
        this.m4bankErrorDialog = true
      })
    },

    kaspiQRPaid() {
      this.kaspiQRDialog = false
      this.register()
    },

    halykQRPaid(status) {
      this.halykQRPaymentDialog = false
      this.m4bankType = 'HALYK_QR'
      this.m4bankAttributes = {
        merchantName: this.organization.businessName,
        dateTime: status.paymentDate,
        operationDay: null,
        transactionNumber: status.billId,
        terminalId: status.terminal,
        maskedPan: status.cardMask,
        authorizationCode: null,
        rrn: status.reference,
      }
      this.register()
    },

    // Возврат денег прошёл (PAID) - фискализируем возвратный чек с атрибутами платежа
    halykQRRefunded(status) {
      this.halykQRRefundDialog = false
      this.m4bankType = 'HALYK_QR'
      this.m4bankAttributes = {
        merchantName: this.organization.businessName,
        dateTime: status.paymentDate,
        operationDay: null,
        transactionNumber: status.refundBillNumber || String(status.refundId),
        terminalId: status.terminal,
        maskedPan: status.cardMask,
        authorizationCode: null,
        rrn: status.reference,
      }
      this.register()
    },
  },
}
</script>

<style lang="stylus" scoped>
.fixed-bottom {
  position: fixed;
  bottom: 30px;
  width: 100%;
  max-width: 400px;
  padding: 0px 30px;
  left: 50%;
  transform: translateX(-50%);
}

.kaspi-qrcode-img
  position absolute
  margin-top 70px

.kaspi-qrcode
  display inline-block
  padding 8px 8px 1px 8px
  background #fffffe
  background-image linear-gradient(#fffffe, #fffffe)

.kaspi-corners
  display inline-table
  padding 10px
  background:
    linear-gradient(to right, #F14834 4px, transparent 4px) 0 0,
    linear-gradient(to right, #F14834 4px, transparent 4px) 0 100%,
    linear-gradient(to left, #F14834 4px, transparent 4px) 100% 0,
    linear-gradient(to left, #F14834 4px, transparent 4px) 100% 100%,
    linear-gradient(to bottom, #F14834 4px, transparent 4px) 0 0,
    linear-gradient(to bottom, #F14834 4px, transparent 4px) 100% 0,
    linear-gradient(to top, #F14834 4px, transparent 4px) 0 100%,
    linear-gradient(to top, #F14834 4px, transparent 4px) 100% 100%
  background-repeat no-repeat
  background-size 30px 30px
</style>
